import React, { useMemo } from 'react'
import { AppleFilled, AppleOutlined, CheckCircleOutlined, CloseCircleOutlined, CreditCardOutlined, DollarCircleOutlined, GoogleCircleFilled, GoogleOutlined, WalletOutlined } from '@ant-design/icons'

import styles from "./styles.module.scss"
import clsx from 'clsx'
import { MERCHANT } from 'utils/enums'
import { Button, Tooltip } from 'antd'


const Icon = {
    [MERCHANT.Cash]: DollarCircleOutlined,
    [MERCHANT.Stripe]: CreditCardOutlined,
    [MERCHANT.Wallet]: WalletOutlined,
    [MERCHANT.ApplePay]: AppleOutlined,
    [MERCHANT.GooglePay]: GoogleOutlined
}

const Text = {
    [MERCHANT.Cash]: 'Cash Payment',
    [MERCHANT.Stripe]: '',
    [MERCHANT.Wallet]: 'Wallet'
}

const Status = {
    Neutral: 0,
    Success: 1,
    Fail: 2
}

export default function PartialPaymentMethodItem({ merchant, brand,
    last4Digits, isSelected, onClick, disabled, text, paymentMethodId,
    handleSubmit, handleCharge,
    onApply,
    isSplitPayment,
    transactions
}) {
    const IconComponent = Icon[merchant]

    const isApplyDisabled = useMemo(() => {
        if (merchant === MERCHANT.Wallet && isSelected === false) {
            return "Please Select A Wallet"
        }
        return false
    }, [merchant, isSelected])

    const wasLastPaymentSuccessful = useMemo(() => {
        let status = false
        for (let transaction of transactions) {
            if (transaction.status === "Paid") {
                status = true
            } else {
                status = false
            }
        }
        return status
    }, [transactions])


    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={clsx(styles.partialPaymentMethodItem, isSelected && styles.active,
                disabled && styles.disabled
            )}
                onClick={disabled ? () => { } : onClick}
            >
                <div className={styles.partialPaymentMethodIconContainer}>
                    {
                        // merchant === 'cash' ? <DollarCircleOutlined className={styles.partialPaymentMethodIcon} /> : <CreditCardOutlined className={styles.partialPaymentMethodIcon} />
                    }
                    {
                        IconComponent && <IconComponent className={styles.partialPaymentMethodIcon} />
                    }
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexGrow: 1 }}>
                    <div>
                        {
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div className={styles.partialPaymentMethodItemText}>{brand ?? Text[merchant]} {text}</div>
                            </div>
                        }
                        {last4Digits &&
                            <div className={styles.partialPaymentMethodItemSubtext}> ****{last4Digits}</div>
                        }
                    </div>
                    {transactions?.length > 0 ? wasLastPaymentSuccessful === true ? <CheckCircleOutlined style={{
                        fontSize: 20,
                        color: '#52c41a'
                    }} /> : <CloseCircleOutlined style={{
                        fontSize: 20,
                        color: '#f5222d'
                    }} /> : <></>}

                </div>
            </div>

            {
                isSplitPayment && <Button type="text" onClick={onApply}
                    disabled={!isSelected || disabled}
                >Apply</Button>
            }



        </div>
    )
}
